module.exports = __webpack_public_path__ + "media/entities/2202-38a7d1db.png";